/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Col_ExportInputs */

const en_hub_col_export = /** @type {(inputs: Hub_Col_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const id_hub_col_export = /** @type {(inputs: Hub_Col_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekspor`)
};

/**
* | output |
* | --- |
* | "Export" |
*
* @param {Hub_Col_ExportInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_col_export = /** @type {((inputs?: Hub_Col_ExportInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Col_ExportInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_col_export(inputs)
	return en_hub_col_export(inputs)
});